"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSantaMembersAPI = function (santaMembersAppDefId, sdk) {
    var getAPI = function () {
        return new Promise(function (resolve, reject) {
            sdk.getPublicAPI({ appDefinitionId: santaMembersAppDefId }, function (api) { return resolve(api); }, function (err) { return reject("Failed to get santa members API: " + err); });
        });
    };
    var navigateToMember = function (memberId, memberSlug) {
        return getAPI().then(function (api) { return api.navigateToMember(__assign({ memberId: memberId }, (memberSlug ? { memberSlug: memberSlug } : {}))); });
    };
    var navigateToSection = function (section) {
        return getAPI().then(function (api) { return api.navigateToSection(section); });
    };
    var getNavigatableRoles = function () { return getAPI().then(function (api) { return api.getNavigatableRoles(); }); };
    return {
        getAPI: getAPI,
        navigateToMember: navigateToMember,
        navigateToSection: navigateToSection,
        getNavigatableRoles: getNavigatableRoles,
    };
};
//# sourceMappingURL=santa-members-api.js.map